import { Dropdown } from "@hellocarbo/lasagne";
import { use } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useParams } from "react-router";

import { LANGUAGES } from "@/constants/languages";
import { PortalContainerContext } from "@/contexts";
import { getPathnameWithNewLang } from "@/utils/language";

const LanguageSelector = () => {
  const { t, i18n } = useTranslation();
  const { container } = use(PortalContainerContext);
  const { lang } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  let defaultLang = LANGUAGES.fr;

  if (lang && Object.values(LANGUAGES).includes(lang as LANGUAGES)) {
    defaultLang = lang as LANGUAGES;
  }

  const handleChangeLanguage = (newLang: string) => {
    const newPathname = getPathnameWithNewLang(location.pathname, newLang);
    // navigate to re-run loader and fetch translated industries
    navigate(`${newPathname}${location.search}`, { replace: true }); // Replace the current entry in the history stack instead of pushing a new one
    i18n.changeLanguage(newLang);
  };

  return (
    <Dropdown
      portalContainer={container as Element}
      className="w-[100px]"
      size="medium"
      defaultValue={defaultLang}
      onChange={handleChangeLanguage}
      groups={[
        {
          items: Object.values(LANGUAGES).map((lang) => ({
            label: t(`common:language.${lang}`),
            value: lang,
          })),
        },
      ]}
    />
  );
};

export default LanguageSelector;
